import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import SelectElementCmp from '@/utils/SelectElementCmp';
import ClientsAreaApiService from '@/modules/clients/services/ClientsAreaApiService';
import { useTranslation } from 'react-i18next';

const SelectFacilities = ({ value, onChange, filters, form, ...props }) => {
  const additionalParams = useMemo(() => ({
    forceSize: true,
    size: 1000,
    useProjections: true,
    projections: {
      name: 1,
    }
  }), []);

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v._id || v) : undefined;
  }, [value]);

  const {t} = useTranslation('registers');

  const handleOnChange = useCallback((val) => {
    onChange(val);
    form?.setFieldValue('areas', val);
  }, [form, onChange]);

  return (
    <SelectElementCmp
      queryKey={'register-facilities-select'}
      service={ClientsAreaApiService}
      includeValue={''}
      value={currentValue}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      mode="multiple"
      allOption={{ show: true, label: t('selectAllFacilities'), value: 'all', excludeValueFromFilters: true }}
      filters={filters}
      additionalParams={additionalParams}
      {...props}
      defaultValue={() => []}
      showDefaultValue
    />
  );
};

SelectFacilities.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  establishments: PropTypes.array,
  currentSelection: PropTypes.array,
  areasTotal: PropTypes.number,
  setAreas: PropTypes.number,
  form: PropTypes.object,
};
SelectFacilities.defaultProps = {
  entity: {},
};

export default memo(SelectFacilities);

const FacilitiesView = ({entity}) => {

  return (
    <div className="w-full">
      {entity?.areas?.length > 0
        ? (
          <div className="flex items-center justify-start flex-wrap gap-3">
            {entity?.areas.map(v => (
              <Tag key={v?._id}>{v.name}</Tag>
            ))}
          </div>
        ) : 'N/A'}
    </div>
  );
};

FacilitiesView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * @param {Object} form this is the value of the dataIndex of the table
 * @param {Object} entity this is the value of the dataIndex of the table
 * */
export const renderFacilities = (value, form, entity) => {

  return (
    <FacilitiesView value={value} entity={entity}/>
  );
};
